import React from 'react';
import PropTypes from 'prop-types';
import FeaturedItem from './FeaturedItem';
import './FeaturedItems.scss';

const FeaturedItems = props =>
  (<section className="featured-items">
    {props.items.map((item, i) => <FeaturedItem key={i} {...item} reversed={i % 2 === 1} />)}
  </section>);

FeaturedItems.propTypes = {
  items: PropTypes.array.isRequired,
};

export default FeaturedItems;
